// extracted by mini-css-extract-plugin
export default {"imageWrapper":"jN-z","twoColumnImage":"kN-z"};